import React from 'react';
import { Text, Box } from 'core/components';

const DataResolutionIndicator = ({ dataResolution, avgConfiguredSamplingRate, useConfiguredSamplingRate = false }) => {
  // Only use avgConfiguredSamplingRate logic when explicitly requested (for Avg Configured Sampling Rate row)
  if (useConfiguredSamplingRate && avgConfiguredSamplingRate && avgConfiguredSamplingRate !== 'N/A') {
    // Parse the sampling rate (e.g., "1:2.5" -> 2.5)
    const parseSamplingRate = (rateString) => {
      const match = rateString.match(/^1:(\d+(?:\.\d+)?)$/);
      return match ? parseFloat(match[1]) : null;
    };

    const samplingRatio = parseSamplingRate(avgConfiguredSamplingRate);
    if (samplingRatio && samplingRatio > 1) {
      if (samplingRatio > 2) {
        // More than 1:2 - red background with "Low Resolution"
        return (
          <Box
            ml={1}
            px={2}
            py={1}
            style={{ backgroundColor: 'rgba(255, 138, 128, 0.6)' }}
            borderRadius="3px"
            display="inline-block"
          >
            <Text fontSize="small" color="#333" fontWeight="500">
              ⚠ Low Resolution
            </Text>
          </Box>
        );
      }
      // More than 1:1 up to 1:2 - yellow background with "Downsampled"
      return (
        <Box
          ml={1}
          px={2}
          py={1}
          style={{ backgroundColor: 'rgba(255, 235, 59, 0.6)' }}
          borderRadius="3px"
          display="inline-block"
        >
          <Text fontSize="small" color="#333" fontWeight="500">
            ⚠ Downsampled
          </Text>
        </Box>
      );
    }
    return null;
  }

  // Use dataResolution logic (for Data Resolution row)
  if (dataResolution === 'low') {
    return (
      <Box
        ml={1}
        px={2}
        py={1}
        style={{ backgroundColor: 'rgba(255, 138, 128, 0.6)' }}
        borderRadius="3px"
        display="inline-block"
      >
        <Text fontSize="small" color="#333" fontWeight="500">
          ⚠ Low Resolution
        </Text>
      </Box>
    );
  }

  if (dataResolution === 'downsampled') {
    return (
      <Box
        ml={1}
        px={2}
        py={1}
        style={{ backgroundColor: 'rgba(255, 235, 59, 0.6)' }}
        borderRadius="3px"
        display="inline-block"
      >
        <Text fontSize="small" color="#333" fontWeight="500">
          ⚠ Downsampled
        </Text>
      </Box>
    );
  }

  // For 'ok' or any other value, don't display anything
  return null;
};

export default DataResolutionIndicator;
